import Settings from "../Component/Settings";
import { connect } from 'react-redux';
import {
  getFranchise,
  getUserDetail,
  getUserGroup,
  editUserDetail,
  getNotificationById,
  updateNotification,
  getUserRoles
} from "../../../Action";

const mapStateToProps = (state) => {
  const {
    franchise,
    userDetail,
    userGroup,
    notifications,
    userRoles,
    errors
  } = state.Settings;
  return {
    franchise,
    userDetail,
    userGroup,
    notifications,
    userRoles,
    errors
  }
}
const actionCreators = {
  getFranchise,
  getUserDetail,
  getUserGroup,
  editUserDetail,
  getNotificationById,
  updateNotification,
  getUserRoles
}

export default (connect(mapStateToProps, actionCreators)(Settings));